<template>
  <el-row type="flex" align="middle" class="nav-header">
    <el-col :span="4" class="flex items-center">
      <router-link to="/" class="flex items-center">
        <img class="nav-logo" src="@/assets/layout/nav_logo.png" alt="logo" />
      </router-link>
    </el-col>

    <el-col :span="20" class="flex items-center justify-end">
      <mg-space>
        <div class="flex items-center">
          <img class="mr-5 icon" src="@/assets/layout/shop.png" />
          {{ shopName }}
        </div>

        <div class="flex items-center" :style="{ width: `${$pxToRem(224)}`, marginLeft: `${$pxToRem(40)}` }">
          <img class="mr-5 icon" src="@/assets/layout/timer.png" />
          {{ realTimeClock }}
        </div>
        <ul class="flex items-center justify-end">
          <li class="flex items-center">
            <el-dropdown @command="handleCommand">
              <span class="flex items-center">
                <img class="nav-avatar mr-5" src="@/assets/layout/nav_avatar.png" alt="avatar" />
                {{ employeeName }}
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="clearLocalCache">{{ $t('清除缓存') }}</el-dropdown-item>
                <el-dropdown-item command="changePassword">{{ $t('修改密码') }}</el-dropdown-item>
                <el-dropdown-item command="logout">{{ $t('退出登录') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
        <el-button v-if="canHandover" size="mini" type="primary" @click="handleHandoverClick">
          {{ $t('交接班') }}
        </el-button>
        <div class="operation">
          <img
            v-if="showMiniCodeButton"
            src="@/assets/common/wechat-mini.png"
            title="店务助手小程序"
            @click="showBusinessAssistantMiniCode = true"
          />
          <div>
            <div @click="handleNotificationsClick" class="notice flex" alt="公告">
              <img src="@/assets/common/notice.png" alt="公告" />
              <div class="badge" v-if="noticeRemindTotalNums">{{ noticeRemindTotalNums }}</div>
            </div>
            <Notifications ref="Notifications" />
          </div>
          <div class="feedback flex" alt="反馈">
            <img
              v-if="!isDisabledGlobalPermissionFeedBack"
              src="@/assets/common/feedback.png"
              :title="$t('反馈')"
              @click="handleFeedback"
            />
            <div class="badge" v-if="feedbackUnreadCount">{{ feedbackUnreadCount }}</div>
          </div>

          <lang-select class="lang-select" />
          <img src="@/assets/common/refresh.png" :title="$t('刷新页面')" @click="handleReload" />
          <template v-if="!isAndroid">
            <img src="@/assets/common/minImg.png" :title="$t('缩小窗口')" @click="onMinimize" />
            <img src="@/assets/common/fullImg.png" :title="$t('放大窗口')" @click="onFullScreen" />
            <img src="@/assets/common/closeImg.png" :title="$t('关闭窗口')" @click="onQuit" />
          </template>
        </div>
      </mg-space>
    </el-col>
    <ResetPassword ref="resetPassword" />
    <Feedback ref="feedback" />
    <OperationManual ref="operationManual" />

    <mg-dialog
      append-to-body
      :visible.sync="showBusinessAssistantMiniCode"
      title="店务助手小程序"
      :show-footer="false"
      :width="$pxToRem(300)"
    >
      <div class="w-full flex justify-center pb-20">
        <img
          :style="{ width: $pxToRem(200), height: $pxToRem(200) }"
          src="https://sh-oss-mg.oss-cn-shanghai.aliyuncs.com/dh-pos-updater/prod/file-read-55796.jpeg"
        />
      </div>
    </mg-dialog>
  </el-row>
</template>
<script>
  import i18n from '@/locale'
  import { mapActions, mapGetters } from 'vuex'
  import { ChangePwdStorage } from '@/utils/storage'
  import { projectName } from '@/config'
  import { ipc } from '@/utils/ipcRenderer'
  import ipcApiRoute from '@/constants/ipcApiRoute'
  import { refreshShopToken } from '@/api/merchant/employee'
  import { isAndroid } from '@/utils'
  export default {
    name: 'Header',
    computed: {
      ...mapGetters({
        employeeName: 'user/employeeName',
        shopName: 'user/shopName',
        noticeRemindTotalNums: 'notice/noticeRemindTotalNums',
        feedbackUnreadCount: 'feedback/unreadCount',
      }),
      isDisabledGlobalPermissionFeedBack() {
        const route = this.$router.match('/globalFiledPermission')
        if (route.name === '404') return true
        return !route.meta?.buttons?.some((n) => n.path === 'feedback')
      },
      //是否有交接班权限
      canHandover() {
        const route = this.$router.match('/globalFiledPermission')
        if (route.name === '404') return false
        return route.meta?.buttons?.some((n) => n.path === 'handover')
      },
      // 是否有店务小程序权限
      showMiniCodeButton() {
        const route = this.$router.match('/globalFiledPermission')
        if (route.name === '404') return false
        return route.meta?.buttons?.some((n) => n.path === 'miniCode')
      },
    },

    components: {
      ResetPassword: () => import('@/components/reset-password'),
      Notifications: () => import('@/components/notifications'),
      Feedback: () => import('@/components/feedback'),
      OperationManual: () => import('@/components/operation-manual'),
      langSelect: () => import('@/components/lang-select'),
    },

    data() {
      return {
        projectName: i18n.t(projectName),
        isAndroid,
        // 系统时间
        realTimeClock: null,
        // 店务助手小程序码弹窗展示
        showBusinessAssistantMiniCode: false,
      }
    },

    async created() {
      await this.$nextTick()
      this.clockInterval = setInterval(() => {
        this.realTimeClock = this.dayjs().format(i18n.t('YYYY年M月D日 HH:mm:ss'))
      }, 1000)
    },

    beforeDestroy() {
      if (this.clockInterval) {
        clearInterval(this.clockInterval)
      }
    },

    async mounted() {
      const isNeedUpdatePwd = ChangePwdStorage.get()
      if (isNeedUpdatePwd) {
        setTimeout(() => {
          this.$mgAlert(
            i18n.t('密码已过期或密码强度较低，账号存在风险，请及时修改您的登录密码保障资料安全'),
            i18n.t('安全提示'),
            {
              showCancelButton: false,
              showClose: false,
              closeOnPressEscape: false,
            }
          ).then(() => {
            this.$refs?.resetPassword.handleShow()
          })
        })
      }
    },

    methods: {
      ...mapActions({
        logout: 'user/logout',
        fetchSysBusinessConfig: 'sys/getSysBusinessConfig',
      }),
      // TODO 此刷新方法可能不会完全清除缓存，应该调用壳子的webContents的刷新浏览器方法
      handleReload() {
        window.location.reload()
      },

      handleCommand(command) {
        switch (command) {
          case 'logout':
            this.$mgAlert(i18n.t('您确定要退出{projectName}吗?', { projectName: this.projectName }), i18n.t('温馨提示'))
              .then(() => {
                return this.logout(true)
              })
              .then(() => {
                window.location.reload('/login')
              })
            break
          case 'changePassword':
            this.$refs?.resetPassword.handleShow()
            break
          case 'clearLocalCache':
            this.$mgConfirm(i18n.t('确定清除本地缓存?'), i18n.t('提示')).then(() => {
              this.$store.dispatch('localDB/cleanAndReset')
              refreshShopToken().then((res) => {
                this.$store.dispatch('user/setShopToken', res.data)
              })
            })
            break
        }
      },

      handleHandoverClick() {
        this.$router.push({ name: 'Handover' })
      },
      //最小化
      onMinimize() {
        ipc.send(ipcApiRoute.minimize)
      },
      // 最大化
      onFullScreen() {
        ipc.send(ipcApiRoute.fullScreen)
      },
      //退出
      async onQuit() {
        await this.$mgConfirm(i18n.t('正在退出，是否继续'), i18n.t('提示'))
        ipc.send(ipcApiRoute.quit)
      },
      handleNotificationsClick() {
        this.$refs.Notifications.drawer = true
      },
      handleFeedback() {
        this.$refs.feedback.visible = true
      },
      handleOperationManual() {
        this.$refs.operationManual.visible = true
      },
    },
  }
</script>
<style lang="scss" scoped>
  .nav-header {
    height: 100%;
    .nav-logo {
      height: 36px;
      margin-left: -4px;
      margin-right: 10px;
    }
    .nav-avatar {
      width: 24px;
    }
    .title {
      font-size: 18px;
      font-weight: 600;
    }
    ul li {
      margin-left: 10px;
    }
    .icon {
      width: 24px;
      height: 24px;
    }
  }

  ::v-deep {
    .el-dropdown {
      font-size: 16px;
    }
    .el-button--mini {
      border-radius: 2px;
    }
  }
  .notice {
    position: relative;
    img {
      width: 24px;
      margin-left: 10px;
    }
    .badge {
      position: absolute;
      top: -4px;
      right: -4px;
      width: 16px;
      height: 16px;
      background: #f56c6c;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .feedback {
    position: relative;
    img {
      width: 21px !important;
      margin-left: 10px;
    }
    .badge {
      position: absolute;
      top: -4px;
      right: -4px;
      width: 16px;
      height: 16px;
      background: #f56c6c;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .operation {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 24px;
      aspect-ratio: 1/1;
      margin-left: 10px;
    }
  }
  .lang-select {
    padding-left: 14px;
    padding-right: 0;
  }
</style>
